const rubyScript = `##############################
#
# This copyright in this script belongs to Thales Group Limited (“Thales”).  
# It is provided to you for evaluation purposes only, and may therefore not form 
# part of the code used in any services which Thales may contract to provide 
# to you.  It may not be distributed to any third party or used for any purpose 
# other than the evaluation of the project currently being discussed between us.
# The intellectual property rights in any amendment or alteration that you may 
# make to this code shall automatically vest in Thales.  This script should 
# not be construed as being a representation, warranty or promise (whether 
# express or implied).
#
##############################

require 'soap/wsdlDriver'
require 'base64'
require 'digest/md5'
require 'FileUtils'

# This class defines the parameters that should be passed to the web method
# In this case, we only need to send a CardImageId
class GetImage
	def initialize(aKey, aCardImageId)
		@imageDelivery_Key = aKey
		@cardImageId = aCardImageId
	end
	def imageDelivery_Key
		@imageDelivery_Key
	end
	def cardImageId
		@cardImageId
	end
end

# This class defines the parameters that should be passed to the receipt web method
# In this case, we only need to send a CardImageId and a "success" flag
class SendReceipt
	def initialize(aKey, aCardImageId, aSuccess)
		@imageDelivery_Key = aKey
		@cardImageId = aCardImageId
		@success = aSuccess
	end
	def imageDelivery_Key
		@imageDelivery_Key
	end
	def cardImageId
		@cardImageId
	end
	def success
		@success
	end
end

puts ""

if (ARGV.length >= 3)
	case ARGV[0]
	when "devserver"
		environment = "devserver.serversidegraphics.com"
	when "uat"
		environment = "uat.serversidegraphics.com"
	when "us"
		environment = "us.personalcard.net"
	else
		environment = ARGV[0]
	end

	key = ARGV[1]
	
	# This is the referenceId we want to pass to the web method
	reqCardImageId = ARGV[2]

    receipt = ARGV[3]
	
#  receipt = false
#
#  if (ARGV.length >= 4)
#    ARGV[3 .. -1].each do |x|
#      receipt = true if (x == "receipt") 
#    end
#  end

else
	puts "Usage:\n\truby GetImage.rb <environment> <key> <cardimageid> <receipt>"
	puts ""
	puts "Environment can be: 'devserver', 'uat' or 'us'"
	puts "Receipt can be: 'receipt', 'receipt_only=true' or 'receipt_only=false'"
  puts ""
  puts "Receipt is optional. If 'receipt' is used, the script will call the receipt"
  puts "web method for each image received. The receipt will be true or false depending"
  puts "on the hash verification"
	Kernel.exit
end

# First, if necessary, create a folder with the fi name
FileUtils.mkdir(key) unless (File.directory?(key))

# Here we set up the connection to the web service by referencing the WSDL
WSDL_URL = "http://" + environment + "/AllAboutMe/services/PCS/dispatch.asmx?WSDL"
soap_client = SOAP::WSDLDriverFactory.new(WSDL_URL).create_rpc_driver
soap_client.default_encodingstyle = SOAP::EncodingStyle::ASPDotNetHandler::Namespace 

# The next line will dump the XML request and response into files with the specified filename ending
# This helps with debugging and understanding how the web method call works
soap_client.wiredump_file_base = key + "\\soap-log.txt"

if (receipt !~ /^receipt_only=/)

	puts "Calling " + WSDL_URL
	puts "Method: GetImage"
	puts "Key: " + key
	puts "CardImageId: " + reqCardImageId
	puts

	reqParams = GetImage.new(key, reqCardImageId)

	# Here we actually call the method
	result = soap_client.GetImage(reqParams)

	# Let's have a look at the resulting ErrorCode and print it out
	myErrorCode = result['GetImageResult']["ErrorCode"]
	puts "ErrorCode: " + myErrorCode

	# If it's zero ("0") everything was successfull
	if (myErrorCode == "0") then
		# Grab all the fields returned by the method
		myHashValue = result['GetImageResult']["HashValue"]
		myCardImageId = result['GetImageResult']["CardImageID"]
		# The Image (binary data) is encoded in base64 since the web service responds in XML
		myImage = Base64.decode64(result['GetImageResult']["Image"])
		
		puts "HashValue: " + myHashValue
		puts "CardImageID: " + myCardImageId

		# Let's check the HashValue and see if the Image was corrupted
		# All we need to do is calculate the MD5 hash of the Image and compare it to the HashValue
		calcHash = Digest::MD5.hexdigest(myImage)
		if (calcHash == myHashValue)
			puts "HashValue matches Image"
	    imageOk = true
		else
			puts "HashValue doesn't match calculated hash (" + calcHash + ")"
	    imageOk = false
		end

		# Finally, we'll save the image to a local file
	  myFilename = key + "\\" + myCardImageId + ".jpg"
	  aFile = File.new(myFilename, "w")
		aFile.binmode
		aFile.print(myImage)
		aFile.close

	    # If requested, we now a receipt back to the server
	    if (receipt == "receipt")
			puts
			puts "Method: SendReceipt"
			puts "Key: " + key
			puts "CardImageId: " + reqCardImageId
			puts "Success: " + imageOk.to_s
			puts

			myReceipt = SendReceipt.new(key, myCardImageId, imageOk)
	      
	      # Here we actually call the receipt method
	      receipt_result = soap_client.SendReceipt(myReceipt)
	      
	      # Let's have a look at the resulting ErrorCode and print it out
	      myReceiptErrorCode = receipt_result["SendReceiptResult"]
	      puts "Receipt ErrorCode: " + myReceiptErrorCode
	    end
	end
else
	receipt_value = receipt.split(/=/)[1]
	puts "Calling " + WSDL_URL
	puts "Method: SendReceipt"
	puts "Key: " + key
	puts "CardImageId: " + reqCardImageId
	puts "Success: " + receipt_value
	puts

	myReceipt = SendReceipt.new(key, reqCardImageId, receipt_value)

	# Here we actually call the receipt method
	receipt_result = soap_client.SendReceipt(myReceipt)

	# Let's have a look at the resulting ErrorCode and print it out
	myReceiptErrorCode = receipt_result["SendReceiptResult"]
	puts "Receipt ErrorCode: " + myReceiptErrorCode
end`;

export default rubyScript ;